var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTermsAndConditions(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.7,
    height: 16.523,
    viewBox: "0 0 12.7 16.523",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_23890",
    "data-name": "Group 23890",
    transform: "translate(-636.551 -310.512)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23890-2",
    "data-name": "Group 23890",
    transform: "translate(637.005 311.012)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_4",
    "data-name": "Subtraction 4",
    d: "M10.606,15.523H1.1A1.226,1.226,0,0,1,0,14.437V1.149A1.291,1.291,0,0,1,1.51,0c.82,0,1.661,0,2.472,0H7.3A1.391,1.391,0,0,1,8.358.438l.159.154.037.041c.15.15.3.3.452.449l.233.231.048.048c.64.634,1.3,1.29,1.954,1.929a1.887,1.887,0,0,1,.459.756V14.561a1.269,1.269,0,0,1-1.093.962Zm-4.752-.969c1.272,0,2.58,0,4.238.007.443,0,.642-.189.642-.611l0-.786c0-2.582-.008-5.252.006-7.908,0-.281-.077-.371-.32-.371h-.054c-.173.008-.353.013-.567.013l-.3,0H9.349c-.15,0-.3,0-.45,0a1.817,1.817,0,0,1-2.07-2.021c0-.094,0-.187,0-.28,0-.047,0-.09,0-.136a9.592,9.592,0,0,1,.016-.975.475.475,0,0,0-.069-.361c-.065-.071-.177-.1-.376-.1H6.373c-.588.009-1.239.014-2.109.014l-1.232,0-1.229,0c-.745,0-.821.079-.821.844V8.409c0,.225,0,.45,0,.676,0,1.554,0,3.163-.008,4.745a.773.773,0,0,0,.159.576.661.661,0,0,0,.486.154C3.278,14.555,4.584,14.554,5.854,14.554ZM7.806,1.467h0V2.1c0,.356,0,.689,0,1.018a.734.734,0,0,0,.634.771,7.122,7.122,0,0,0,.724.031c.151,0,.308,0,.53-.009h.1c.179-.006.33-.008.466-.008l-.857-.849L8.86,2.514c-.346-.342-.691-.686-1.055-1.045Z",
    transform: "translate(0.046)",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43198",
    "data-name": "Path 43198",
    d: "M662.221,376.436c.833,0,1.666.025,2.5-.01.43-.018.388.218.377.484-.01.244.1.509-.357.5-1.706-.025-3.412-.028-5.117,0-.5.008-.346-.295-.379-.545-.044-.33.061-.453.421-.441C660.515,376.454,661.369,376.436,662.221,376.436Z",
    transform: "translate(-656.268 -369.612)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43199",
    "data-name": "Path 43199",
    d: "M662.219,393.168c-.853,0-1.707-.027-2.558.011-.453.02-.364-.247-.365-.495s-.085-.5.365-.494q2.558.042,5.117,0c.451-.007.364.248.365.495s.086.514-.366.494C663.925,393.14,663.071,393.168,662.219,393.168Z",
    transform: "translate(-656.316 -383.445)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43200",
    "data-name": "Path 43200",
    d: "M661.174,408.948c-.528,0-1.057-.024-1.583.007-.479.029-.316-.3-.332-.522s-.078-.471.333-.461q1.613.041,3.228,0c.478-.012.315.3.331.523s.08.486-.333.46C662.272,408.923,661.722,408.948,661.174,408.948Z",
    transform: "translate(-656.278 -397.293)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTermsAndConditions);
export default __webpack_public_path__ + "static/media/termsAndConditions.8658837710617349aa6f52886d6839d0.svg";
export { ForwardRef as ReactComponent };